// fs-auto-complete-address.js

(function () {
  let results = null;
  let input = null;
  let token = null;
  let latestRequestId = 0;

  const request = {
    input: "",
    locationRestriction: {
      west: 101.22,
      north: 3.39,
      east: 101.94,
      south: 2.81,
    },
    includedRegionCodes: ["my"],
    origin: {
      lat: 3.1144294519215454,
      lng: 101.58858900884887,
    },
    language: "en-US",
    region: "my",
  };

  function isAutoCompleteAllowed() {
    // Do not declare allow_auto_complete here.
    // If your theme already defines window.allow_auto_complete, we use that.
    // If it is not defined, default to true.
    if (typeof window.allow_auto_complete === "undefined") {
      return true;
    }

    return Boolean(window.allow_auto_complete);
  }

  async function initAddressAutocomplete() {
    results = document.getElementById("address-auto-complete-results");
    input = document.getElementById("recipient-address1");

    if (!results || !input) {
      console.error("Address autocomplete elements not found.");
      return;
    }

    if (!window.google || !google.maps || !google.maps.places) {
      console.error("Google Maps Places library is not loaded.");
      return;
    }

    refreshToken();

    // Prevent duplicate event listeners if the function is called more than once
    if (input.dataset.fsAddressAutocompleteBound === "1") {
      return;
    }

    input.addEventListener("input", makeAcRequest);
    input.dataset.fsAddressAutocompleteBound = "1";
  }

  async function makeAcRequest(event) {
    if (!isAutoCompleteAllowed()) {
      console.log("auto_complete disallowed");
      return;
    }

    const inputValue = event.target.value.trim();

    if (inputValue === "") {
      results.replaceChildren();
      return;
    }

    const currentRequestId = ++latestRequestId;

    request.input = inputValue + " Malaysia";

    try {
      const { suggestions } =
        await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
          request
        );

      // Ignore old responses if user types quickly
      if (currentRequestId !== latestRequestId) {
        return;
      }

      results.replaceChildren();

      if (!suggestions || suggestions.length === 0) {
        return;
      }

      for (const suggestion of suggestions) {
        const placePrediction = suggestion.placePrediction;

        if (!placePrediction) {
          continue;
        }

        const a = document.createElement("a");
        a.href = "#";
        a.innerText = placePrediction.text.toString();

        a.addEventListener("click", function (clickEvent) {
          clickEvent.preventDefault();
          onPlaceSelected(placePrediction.toPlace());
        });

        const li = document.createElement("li");
        li.appendChild(a);
        results.appendChild(li);
      }
    } catch (error) {
      console.error("Autocomplete request failed:", error);
      results.replaceChildren();
    }
  }

  async function onPlaceSelected(place) {
    try {
      await place.fetchFields({
        fields: [
          "displayName",
          "formattedAddress",
          "adrFormatAddress",
          "addressComponents",
          "postalAddress",
        ],
      });

      console.log("displayName:", place.displayName);
      console.log("formattedAddress:", place.formattedAddress);
      console.log("adrFormatAddress:", place.adrFormatAddress);
      console.log("addressComponents:", place.addressComponents);
      console.log("postalAddress:", place.postalAddress);

      const displayName = place.displayName || "";
      const formattedAddress = place.formattedAddress || "";

      const postalCode =
        place.postalAddress?.postalCode ||
        getAddressComponent(place.addressComponents, "postal_code");

      const locality =
        place.postalAddress?.locality ||
        getAddressComponent(place.addressComponents, "locality") ||
        getAddressComponent(place.addressComponents, "postal_town") ||
        getAddressComponent(
          place.addressComponents,
          "administrative_area_level_2"
        ) ||
        getAddressComponent(
          place.addressComponents,
          "administrative_area_level_1"
        );

      let addressWithoutPostalCode = formattedAddress;

      if (postalCode && formattedAddress.includes(postalCode)) {
        addressWithoutPostalCode = formattedAddress.split(postalCode)[0];
      }

      addressWithoutPostalCode = cleanAddress(addressWithoutPostalCode);

      let address1 = addressWithoutPostalCode;

      if (
        displayName &&
        addressWithoutPostalCode &&
        !addressWithoutPostalCode
          .toLowerCase()
          .includes(displayName.toLowerCase())
      ) {
        address1 = displayName + ", " + addressWithoutPostalCode;
      }

      if (!address1 && displayName) {
        address1 = displayName;
      }

      const addressInput = document.getElementById("recipient-address1");
      const cityInput = document.getElementById("recipient-city");
      const postcodeInput = document.getElementById("recipient-postcode");

      if (addressInput) {
        addressInput.value = address1 || "";
      }

      if (cityInput) {
        cityInput.value = locality || "";
      }

      if (postcodeInput) {
        postcodeInput.value = postalCode || "";
      }

      results.replaceChildren();

      refreshToken();
    } catch (error) {
      console.error("Failed to fetch selected place:", error);
    }
  }

  function getAddressComponent(addressComponents, type) {
    if (!addressComponents || !Array.isArray(addressComponents)) {
      return "";
    }

    const component = addressComponents.find(function (c) {
      return c.types && c.types.includes(type);
    });

    if (!component) {
      return "";
    }

    return component.longText || component.shortText || "";
  }

  function cleanAddress(address) {
    if (!address) {
      return "";
    }

    return address
      .replace(/\s+/g, " ")
      .replace(/,\s*$/, "")
      .trim();
  }

  function refreshToken() {
    token = new google.maps.places.AutocompleteSessionToken();
    request.sessionToken = token;
  }

  // This must be global because your Google Maps script uses:
  // callback=init_address_autocomplete
  window.init_address_autocomplete = initAddressAutocomplete;
})();